import { memo } from 'react';

import { TRepetitionAction } from 'core/helpers/repetition';

import { TWordCardSide } from '../shared';
import ResultAfterPane from './After';
import Before from './Before';

type TProps = {
  word: TWord;
  side: TWordCardSide;
  disabled: boolean;
  goNext: () => void;
  finishWord: (action: TRepetitionAction) => Promise<void>;
  isLast: boolean;
  exercise: TExercise;
  className?: string;
};

const ResultWordPane: React.FC<TProps> = ({
  side,
  disabled,
  goNext,
  finishWord,
  isLast,
  word,
  exercise,
  className,
}) =>
  side === TWordCardSide.back ? (
    <ResultAfterPane
      className={className}
      disabled={disabled}
      goNext={goNext}
      word={word}
      finishWord={finishWord}
      exercise={exercise}
    />
  ) : (
    <Before
      className={className}
      disabled={disabled}
      goNext={goNext}
      isLast={isLast}
    />
  );

export default memo(ResultWordPane);
